import { faFileDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Icon } from "@iconify/react";
import Breadcrumbs from "components/Breadcrumbs";
import HomeSlider from "components/HomeSlider";
import SEO from "components/SEO";
import SessionContext from "components/session/SessionContext";
import { ShareSocial } from "components/ShareSocial";
import Text from "components/Text";
import { pagePadding } from "data/commonClasses";
import {
  capitalize,
  dateFormatter,
  fetchFromAPI,
  fetchPost,
  getCookie,
  getTranslationContent,
  isArray,
} from "functions";
import { formatHTML } from "functions/utils";
import Image from "next/image";
import LinkNext from 'next/link';
import { useContext, useEffect, useState } from "react";
import ReactPlayer from "react-player";
import useStyles from "styles/New.Style";
import { twMerge } from "tailwind-merge";
import useTranslation from "translations/hooks/useTranslation";

export default function News({ data, news }) {
  const classes = useStyles();
  const { t } = useTranslation();

  let {
    session: {
      user: { _id, authToken },
      lang,
    },
  } = useContext(SessionContext);
  let isAr = lang === "ar";
  let category = data?.category?.name || "category";
  let categorySlug =
    data?.category?.slug ||
    (category ? category.toLowerCase().replace(/\s+/g, "-") : "announcements");

  const [likeCount, setLikeCount] = useState(data?.interactionsSummary?.likes);
  const [likeByMe, setLikeByMe] = useState(
    data?.interactionsSummary?.likedByMe || false
  );

  useEffect(() => {
    async function handleView() {
      let reqBody = { _id: data?._id, collection: "news" };
      let response = {};
      response = await fetchFromAPI({
        api: "interactionSummary/view",
        reqBody,
      });
    }
    handleView();
  }, [data?._id]); //eslint-disable-line react-hooks/exhaustive-deps

  async function handleLike() {
    setLikeCount(likeCount + 1);
    let header = { _id, authToken };
    if (authToken) {
      if (likeByMe) {
        setLikeCount(likeCount - 1);
        setLikeByMe(false);
      } else {
        setLikeCount(likeCount + 1);
        setLikeByMe(true);
      }
    } else setLikeCount(likeCount + 1);
    let reqBody = { _id: data?._id, collection: "news" };
    let response = {};
    response = await fetchFromAPI({
      api: "interactionSummary/like",
      reqBody,
      header,
    });
    if (response.status == "error") {
      if (authToken) {
        if (likeByMe) {
          setLikeCount(likeCount - 1);
          setLikeByMe(false);
        } else {
          setLikeCount(likeCount + 1);
          setLikeByMe(true);
        }
      } else setLikeCount(likeCount - 1);
    }
  }

  async function handleShare() {
    navigator.clipboard.writeText(window?.location?.href);
    let reqBody = { _id: data._id, collection: "news" };
    await fetchFromAPI({ api: "interactionSummary/share", reqBody });
  }

  var breadcrumbs = [
    { text: t("home"), href: "/" },
    { text: t(capitalize(category)), href: `/news/${categorySlug}` },
    { text: `${getTranslationContent(data, "title", lang) || ""}` },
  ];

  const bodyContent = getTranslationContent(data, "body", lang) || "";
  const articleTitle = getTranslationContent(data, "title", lang) || "";
  // const [indexpic, setIndexPic] = useState(0);

  // function showSlides() {
  //   let newIndex = indexpic + 1;
  //   if (newIndex > data?.extraImages?.length - 1) newIndex = 0;
  //   setIndexPic(newIndex);
  // }

  // setTimeout(showSlides, 5000);

  // console.log({data});

  return (
    <div className={twMerge("flex flex-col w-full min-h-screen", pagePadding)}>
      <SEO
        title={articleTitle}
        description={formatHTML(bodyContent) || articleTitle || ""}
        og_image={data?.image || data?.extraImages?.[0] || null}
      />
      <Breadcrumbs items={breadcrumbs} />
      <div className="flex flex-col w-full my-5 ">
        {data?.image || data?.extraImages ? (
          <div className={"bg-lightGrey rounded-button"}>
            <div className={"flex justify-center"}>
              {isArray(data?.extraImages) && data.extraImages.length > 1 ? (
                <div className="w-full aspect-video">
                  <HomeSlider
                    objectFit="contain"
                    items={data?.extraImages?.map((item, id) => {
                      return { _id: id, image: item };
                    })}
                    lang={lang}
                  />
                </div>
              ) : data?.image ? (
                // <Image
                //     src={`${data?.image}`}
                //     alt='news image'
                //     layout='responsive'
                //     height={500}
                //     width={600}
                // />
                <div className="h-[50vh] w-10/12 md:w-1/2 relative">
                  <Image
                    src={data?.image}
                    alt="training image"
                    layout="fill"
                    className="object-contain"
                    style={{
                      borderRadius: "12px",
                    }}
                  />
                </div>
              ) : null}
            </div>
          </div>
        ) : null}

        <div className={classes.newsContainer}>
          <Text
            className="text-input md:text-infoText pt-10"
            text={dateFormatter(data?.createdAt, "D MMMM, YYYY", isAr)}
          />
          <Text
            className="text-black py-1 text-subtitle md:text-sectionTitle"
            text={getTranslationContent(data, "title", lang)}
          />

          <div
            className={`flex flex-row mt-2 gap-5 items-center justify-center md:justify-start md:items-start`}
          >
            <div
              onClick={handleShare}
              className={"cursor-pointer flex flex-row items-center"}
            >
              <div className="text-input md:text-infoText mr-2 text-transparentBlack">
                {data?.interactionsSummary?.shares} {t("shares")}
              </div>
              <Icon
                icon={"material-symbols:share"}
                className="mr-2 w-5 h-5 text-transparentBlack"
              />
            </div>
            {category == "mortality" ? null : (
              <div
                onClick={handleLike}
                className={"cursor-pointer flex flex-row items-center"}
              >
                <div className="text-input md:text-infoText mr-2 text-transparentBlack">
                  {likeCount} {t("likes")}
                </div>
                <Icon
                  icon={"solar:like-bold"}
                  className="mr-2 w-5 h-5 text-transparentBlack"
                />
              </div>
            )}
            <div className={"flex flex-row items-center "}>
              <div className="text-input md:text-infoText mr-2 text-transparentBlack">
                {data?.interactionsSummary?.views} {t("views")}
              </div>
              <Icon
                icon={"carbon:view-filled"}
                className="mr-2 w-5 h-5 text-transparentBlack"
              />
            </div>
          </div>
            {data?.attachedFile ? (
              <LinkNext href={`${data.attachedFile}`}>
                <a
                  alt={t("file")}
                  target="_blank"
                  rel="noopener noreferrer"
                  download
                  className="flex flex-row items-center justify-center gap-3 min-w-[300px] my-4 py-2 text-transparentBlack hover:opacity-80 text-base md:text-lg"
                >
                <FontAwesomeIcon
                  icon={faFileDownload}
                  className={classes.icon}
                  style={{ width: '1.25rem', height: '1.25rem' }}
                />
                  <span>{t("file")}</span>
                </a>
              </LinkNext>
            ) : null}
          <ShareSocial
            lang={lang}
            articleId={data?._id} // Pass the article ID for short URL generation
            title={articleTitle}
            socialTypes={["facebook", "twitter", "whatsapp"]}
          />
          {bodyContent && bodyContent !== "" ? (
            <div className="bg-lightGrey w-full rounded-button p-5 my-5 flex flex-col">
              <div
                className="text-oeaMain break-words overflow-wrap-break-word whitespace-normal"
                dangerouslySetInnerHTML={{
                  __html: bodyContent,
                }}
              />
            </div>
          ) : null}
          {data?.videoUrl ? (
            <div className="flex justify-center mt-4">
              <ReactPlayer url={`${data && data.videoUrl}`} />
            </div>
          ) : null}
        </div>
      </div>

      {/* <div className={classes.latestNewsContainer}>
        <Title text={t("latestFeeds")} />
        <div className={classes.latestNews}>
          {isArray(news) &&
            news.map((newsItem) => (
              <Link
                key={newsItem._id}
                href="/news/article/[slug]"
                as={`/news/article/${newsItem?.slug}`}
              >
                <div className={classes.latestNewsDiv}>
                  <div className={classes.latestNewsBlock}>
                    <div className={classes.eventImage}>
                      <div
                        style={{
                          width: "100%",
                          height: "100%",
                          zIndex: 0,
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Image
                          src={
                            newsItem.image
                              ? `${newsItem.image}`
                              : "/placeholder.jpg"
                          }
                          alt="news image"
                          height={500}
                          width={500}
                        />
                      </div>
                    </div>
                    <div className={classes.latestNewsTitle}>
                      {getTranslationContent(newsItem, "title", lang)}
                    </div>
                  </div>
                  <div className={classes.latestNewsDate}>
                    {dateFormatter(newsItem.createdAt, "D MMMM, YYYY", isAr)}
                  </div>
                </div>
              </Link>
            ))}
        </div>
      </div> */}
    </div>
  );
}

export async function getServerSideProps(context) {
  let { slug, lang } = context.query;
  let data = {},
    news = [];
  let response = {},
    responseData = {},
    header = {};
  if (context.req)
    header = {
      _id: getCookie("_id", context.req),
      authToken: getCookie("authToken", context.req),
    };
  context.req
    ? (response = await fetchPost({
        apiName: "news",
        reqBody: { limit: 3, page: 1, category: "announcements", lang },
        header,
      }))
    : (response = await fetchFromAPI({
        api: "news",
        reqBody: { limit: 3, page: 1, category: "announcements", lang },
        header: {},
      }));
  context.req
    ? (responseData = await fetchPost({
        apiName: "news",
        reqBody: { slug, lang },
      }))
    : (responseData = await fetchFromAPI({
        api: "news",
        reqBody: { slug, lang },
      }));
  news = response?.response?.news;
  let dataBySlug = responseData?.response;
  dataBySlug?.news && isArray(dataBySlug?.news)
    ? (data = dataBySlug?.news[0])
    : (data = dataBySlug);
  return { props: { data, news } };
}
